@if (label()) {
  <div class="kl-label text-start">
    @if (htmlFor()) {
      <label class="kl-label__text" [attr.for]="htmlFor()">
        {{ label() | translate }}
        @if (labelDescription()) {
          <span class="kl-label__description">({{ labelDescription() | translate }})</span>
        }
        @if (isRequired()) {
          <span class="kl-label__required" aria-hidden="true">*</span>
        }
      </label>
    } @else {
      <span class="kl-label__text">
        {{ label() | translate }}
        @if (labelDescription()) {
          <span class="kl-label__description">({{ labelDescription() | translate }})</span>
        }
        @if (isRequired()) {
          <span class="kl-label__required" aria-hidden="true">*</span>
        }
      </span>
    }
  </div>
}
